import React from 'react';
import ReportsList from './Components/ReportsList/ReportsList';

const Studies = () => {
	return <ReportsList title={'pages.reports.studies'} url={'/api/reports/studies/'} />;
};

export default Studies;
